import { call, select, put } from 'redux-saga/effects'
import FileSaver from 'file-saver'

import { getSessionId, getLocale } from '@global/selectors'

import { showLoader, hideLoader } from '../../../../../services/loader/actions'
import intlSaga from '../../../../../services/translations/intl-saga'
import { error } from '../../../../../services/toastr'

import { groupStackExportMembers } from '../helpers'
import { LOCALE_PREFIX } from '../constants'

export default function* groupStackExportSaga(action) {
    const groupId = action?.data?.groupId
    const groupName = action?.data?.groupName
    const sessionId = yield select(getSessionId)
    const locale = yield select(getLocale)

    yield put(
        showLoader('groupStackExportToXlsLoader', intlSaga.formatMessage(locale, `${LOCALE_PREFIX}.exportingGroup`))
    )

    const fileBlob = yield call(groupStackExportMembers, groupId, groupName, sessionId, locale)

    if (!fileBlob || !fileBlob.size) {
        error({
            id: `${LOCALE_PREFIX}.exportError`,
        })
        yield put(hideLoader('groupStackExportToXlsLoader'))
        return null
    }

    yield put(hideLoader('groupStackExportToXlsLoader'))

    FileSaver.saveAs(fileBlob, `${groupName}.xls`)

    return null
}
